export var FORM_REPOSITORY_WEB_CONFIG = 'FORM_REPOSITORY_WEB_CONFIG';